export default {
	common: {
		noMore: '没有更多了',
		noEmpty: '必传',
		copySuccess: '复制成功',
		copyFail: '复制失败',
		search: '搜索',
		remark: '备注',
		commit: '提交',
		status: '状态',
		revoke: '撤销',
		cancel: '取消',
		confirm: '确认',
	},
	footer: {
		companyValue: '广州仙灵网络科技有限公司',
		addressValue: '广州市天河区荷光路盛达商务园D座505',
		icpValue: '粤ICP备20026950号',
		mapValuelat: '23.132606',
		mapValuelan: '113.375587',
		telValue: '0731-85151461',
		jobValue: '李女士',
		jobEmailValue: `lijiahui{'@'}7pa.com`,
		contactValue: '刘蔚',
		emailValue: `liuwei{'@'}7pa.com`
	}
}